export function formValidation(formType, form) {
    class ValidateForm {
        constructor(form) {
            this.Form = form;
            this.formType = formType;
            this.tippy = tippy;
            this.patterns = {
                email: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                noSpecialChars: /^[^<>=;]+$/,
                noNumbers: /^([^0-9]*)$/,
                noSpaces: /^\S*$/,
                alphaNumeric: /^[a-zA-Z0-9]+$/,
                numeric: /^\d+$/,
                postalCode: /^[a-zA-Z0-9]{1,20}$/,
                tel: /^[0-9]{1,10}$/,
                phoneext: /^[0-9]{1,5}$/,
                name: /^[A-Za-z\s-]{1,50}$/,
                comments: /^[^<>=;]{1,1000}$/,
                state: /^[A-Za-z]{1,50}$/,
                num8: /^[0-9]{8}$/,
                website: /^[^0-9<>=;\s]{1,200}$/,
                company: /^[A-Za-z0-9\s-]{1,100}$/,
                city: /^[^<>=;]{1,25}$/
            };
        }

        validate() {
            
            try {
                const errorFields = [];
                const fields = [...this.Form.querySelectorAll('[validate="onsubmit"]')];
                console.log("VALIDATING! " + fields)

                for (let i = 0, l = fields.length; i < l; i++) {
                    const isValid = this.processField(fields[i]);
                    if (!isValid) errorFields.push(fields[i]);
                }

                if (errorFields.length > 0) {
                    this.setFocus(errorFields[0]);
                    return false;
                }

                const dealerField = document.getElementById('DealerCode');
                if (!this.processField(dealerField)) errorFields.push(dealerField);

                return true;
            } catch (exception) {
                console.error(exception);
                return false;
            }
        }
        processField(field) {
            const validateType = field.getAttribute('requiredtype');
            const isValid = this.validateField(field);

            if (isValid) {
                this.setFieldToValid(field);
            } else {
                let errorMessage = '';

                switch (validateType) {
                    case 'firstname':
                        errorMessage = 'First Name is required and must not contain numbers and should be less than 50 characters.';
                        break;

                    case 'lastname':
                        errorMessage = 'Last Name is required and must not contain numbers and should be less than 50 characters.';
                        break;

                    case 'email':
                        errorMessage = 'Valid Email is required.';
                        break;

                    case 'company':
                        errorMessage = 'Company name is required and should be less than 100 characters.';
                        break;

                    case 'website':
                        errorMessage = 'Website must not contain numbers or spaces and should be less than 200 characters.';
                        break;

                    case 'postalcode':
                        errorMessage = 'Valid Postal Code is required and should contain numbers and letters only and should be less than 20 characters.';
                        break;

                    case 'phoneext':
                        errorMessage = 'Extension can only have numbers.';
                        break;

                    case 'num8Pattern':
                        errorMessage = 'Please only use an 8 digit number for the USDOT/MC number.';
                        break;

                    case 'comments':
                        errorMessage = 'Comments must be less than 1000 characters with no special symbols.';
                        break;

                    case 'usage':
                        errorMessage = 'Truck Use is required.';
                        break;

                    case 'purchaseplan':
                        errorMessage = 'Purchase Plan is required.';
                        break;

                    case 'state':
                        errorMessage = 'State/Province is required.';
                        break;

                    case 'city':
                        errorMessage = 'City required and must be less than 25 characters with no special symbols.';
                        break;

                    case 'country':
                        errorMessage = 'Business Country is required.';
                        break;

                    case 'tel':
                        errorMessage = 'Valid Phone is required.';
                        break;

                    case 'phoneext':
                        errorMessage = 'Extension can only have numbers.';

                    case 'dealer':
                        errorMessage = 'Please select a dealer.';
                        break;

                    default:
                        errorMessage = field.getAttribute('invalidmessage') || 'Invalid input';
                        break;
                }

                this.setFieldToInvalid(field, errorMessage);
            }

            return isValid;
        }

        setFieldToValid(field) {
            // Regular fields
            field.classList.remove('invalid');

            // Special handling for DealerCode to remove invalid class from the parent container
            if (field.id === 'DealerCode') {
                const dealerContainer = document.querySelector('.dealer');
                dealerContainer.classList.remove('invalid'); // Remove invalid class from the container
            }
        }

        setFieldToInvalid(field, errorMessage) {
            // Regular fields
            field.classList.add('invalid');
            this.setEventListener(field);

            // Special handling for DealerCode to apply invalid styling to the parent container
            if (field.id === 'DealerCode') {
                const dealerContainer = document.querySelector('.dealer'); // Select parent container
                dealerContainer.classList.add('invalid'); // Add invalid class to the container

                if (errorMessage) {
                    tippy(dealerContainer, {
                        content: errorMessage,
                        trigger: 'mouseenter', // Show error on hover for better visibility
                        placement: 'top-start'
                    });
                }
                return; // Skip further processing for this special case
            }

            // Default error tooltip handling for other fields
            if (errorMessage && errorMessage !== '') {
                const options = {
                    content: errorMessage,
                    trigger: 'focusin',
                    placement: 'top-start'
                };

                if (this.formType === 'Configurator') {
                    options.appendTo = this.Form;
                }

                tippy(field, options);
            }
        }

        setEventListener(field) {
            const validateType = field.getAttribute('requiredtype');
            if (validateType === 'dealer') {
                document.getElementById('DealerCode')?.addEventListener('dealer-change', (event) => {
                    this.fieldListEvent(event, field);
                });
            } else {
                field.addEventListener('blur', (event) => {
                    this.fieldListEvent(event, field);
                });
            }
        }

        fieldListEvent(event, target) {
            const field = target ? target : event.target;
            const isValid = this.processField(field);
        }

        validateField(field) {
            var _document$getElementB2;
            const value = field.value || '';
            const validateType = field.getAttribute('requiredtype');

            try {

                switch (validateType) {
                    case 'name':
                        return this.patterns.noNumbers.test(value) && this.patterns.noSpaces.test(value) && value.length <= 50;

                    case 'firstname':
                        return this.patterns.name.test(value);

                    case 'lastname':
                        return this.patterns.name.test(value);

                    case 'email':
                        return this.patterns.email.test(value);

                    case 'company':
                        return this.patterns.company.test(value);

                    case 'website':
                        return this.patterns.website.test(value);

                    case 'postalcode':
                        return this.patterns.postalCode.test(value);

                    case 'phoneext':
                        return !value || this.patterns.phoneext.test(value);

                    case 'num8Pattern':
                        return !value || this.patterns.num8.test(value);

                    case 'comments':
                        return !value || this.patterns.comments.test(value);

                    case 'usage':
                        return !value;

                    case 'purchaseplan':
                        return !value;

                    case 'state':
                        return this.patterns.state.test(value);

                    case 'city':
                        return this.patterns.city.test(value);

                    case 'tel':
                        return this.patterns.tel.test(value);

                    case 'phoneext':
                        return !value || this.patterns.phoneext.test(value);

                    case 'sel':
                        const selectedValue = field.value;
                        return selectedValue && selectedValue !== '';

                    case 'dealer':
                        const dealerCode = (_document$getElementB2 = document.getElementById('DealerCode')) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.value;
                        return dealerCode && dealerCode.trim().length > 0;

                    default:
                        return true;
                }
            } catch (e) {
                console.log(e);
            }
        }

        validateState(country, state) {
            if (country === 'US' || country === 'CA') {
                return state.length >= 2;
            }
            return true;
        }

        validatePhone(value) {
            let phone = typeof value === 'string' ? value : String(value);
            phone = phone.replace(/\D/g, '');
            return phone.length >= 10;
        }

        validateText(value) {
            if (typeof value === 'string') {
                return value.length > 1;
            }
            return false;
        }

        setFocus(field) {
            const validateType = field.getAttribute('requiredtype');

            switch (validateType) {
                case 'dealer':
                    const locationField = document.getElementById('DealerLocation');
                    if (locationField) locationField.focus();
                    break;

                default:
                    field.focus();
                    break;
            }
        }
    }

    class TruckLeadValidateForm extends ValidateForm {
        constructor(form, formType, tippy) {
            super(form, formType, tippy);
        }
    }

    return formType === 'Configurator'
        ? new TruckLeadValidateForm(form, formType)
        : new ValidateForm(form);
}